<br><br>
<div class="container text-center">
<div class="card text-center">
    
    
    <div class="card-body">
        <img src="assets/img/vidiooo.jpg" id="logoInf" width="300" height="300" alt="Card image cap">
    <br><br>
      <h5 class="card-title">¿Quiénes somos?</h5>
      <p class="card-text">Vizsio es una microempresa netamente digital y 100% Mexicana dedicada principalmente a
        ofrecer la venta de bebidas alcohólicas a domicilio, al mismo tiempo ofrece un servicio de reparto personalizado a pequeños
        o grandes negocios de la ciudad de #Tehuacán que se dedican a la venta de comida entre otras. </p>
        <p class="card-text">Vizsio abre un espacio digital donde los negocios puedan digitalizarse y generar más
          ingresos, como sabemos hoy en día la tecnología es una clave importante e indispensable para la vida cotidana, apoya consumiendo productos en los negocios de tu ciudad.
          #ConsumeLocal</p>
      <a href="/home" class="btn btn-dark">Regresar</a>
    </div>
    
  </div>
</div>